import { useEffect, useState } from 'react';

import { cn } from '@/utils/cn';

import '../onboarding/onboarding.css';

const STATUS_PHASES = [
	{ text: 'Analyzing your business...', at: 0 },
	{ text: 'Mapping your brand identity...', at: 3000 },
	{ text: 'Identifying your audience...', at: 6000 },
	{ text: 'Almost ready...', at: 9000 },
];

export function BrandLoadingInterstitial() {
	const [statusText, setStatusText] = useState(STATUS_PHASES[0].text);
	const [statusFading, setStatusFading] = useState(false);

	useEffect(() => {
		const timers: ReturnType<typeof setTimeout>[] = [];

		STATUS_PHASES.forEach((phase, i) => {
			if (i === 0) return;
			timers.push(setTimeout(() => setStatusFading(true), phase.at - 150));
			timers.push(
				setTimeout(() => {
					setStatusText(phase.text);
					setStatusFading(false);
				}, phase.at),
			);
		});

		return () => timers.forEach(clearTimeout);
	}, []);

	return (
		<div
			className="animate-onb-fade-in flex w-full flex-1 flex-col items-center
				justify-center"
		>
			<h2
				className="mb-6 bg-gradient-to-r from-blue-400 to-blue-500 bg-clip-text
					text-center text-2xl font-bold tracking-tight text-transparent"
			>
				Building your business profile
			</h2>

			<div
				className="mb-4 h-8 w-8 animate-spin rounded-full border-2
					border-blue-500/20 border-t-blue-500"
			/>

			<div
				className={cn(
					'h-4 text-xs font-medium tracking-wider text-gray-500',
					'transition-opacity duration-200',
					statusFading && 'opacity-0',
				)}
			>
				{statusText}
			</div>
		</div>
	);
}
